module.exports = __webpack_public_path__ + "4828d27a48ef78c7d8f7d962d71d3da2.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/staff_scroll.png
 ** module id = 274
 ** module chunks = 0
 **/